import React from "react";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";
import Atlas from "../sections/Atlas";
import Invite from "../sections/Invite";

const detail = [
  {
    title: "FMCG & Consumer Goods",
    body: "Household, personal care, staples and baby. Modern trade plus marketplaces define the volume; we structure both around a coherent price-pack architecture and category-driven shopper activation."
  },
  {
    title: "Fashion & Luxury",
    body: "Apparel, accessories, footwear and jewellery. Vitalis runs the brand, content and influencer programme alongside Trendyol, Hepsiburada and DTC store activation — coordinated with selective specialty retail."
  },
  {
    title: "Beauty & Cosmetics",
    body: "Skincare, colour, fragrance and derma. We handle Turkish regulatory positioning, creator-led launch programmes, dermocosmetic press, Watsons/Gratis specialty trade and the always-on social and e-commerce engine."
  },
  {
    title: "Food & Beverage",
    body: "Specialty foods, beverages and supplements. From food-regulatory labelling and TARIM compliance support to chef collaborations, on-trade activation and the right place in modern-trade refrigeration."
  },
  {
    title: "Technology & SaaS",
    body: "Consumer apps, B2B SaaS and hardware. We run TR-language demand generation, ABM for enterprise, App Store / Play Store localisation, and the LinkedIn and PR programmes that build credibility in the Turkish tech ecosystem."
  },
  {
    title: "Automotive & Mobility",
    body: "OEMs, EVs, two-wheelers and accessories. Brand campaigns, dealer-network coordination, content and motoring press programmes — calibrated for the realities of the Turkish automotive market and its fast-changing tax environment."
  },
  {
    title: "Travel & Hospitality",
    body: "Hotel groups, OTAs and tourism boards targeting Turkish outbound travellers. We run inspiration content, paid acquisition, conversion-rate optimisation and TR-language customer service for the booking journey."
  },
  {
    title: "Health & Wellness",
    body: "OTC, medical devices, fitness and clinics. Regulatory positioning, physician communication, KOL engagement and the consumer-facing brand and CRM programme that drives long-term adherence."
  },
  {
    title: "Home & Lifestyle",
    body: "Furniture, decor, appliances and pet. Visual content, marketplace activation, partnership with İKEA-adjacent specialty retail and on-trade collaborations with Turkish design and lifestyle publications."
  }
];

const Markets = () => (
  <Frame>
    <Seo title="Sectors" description="The categories Vitalis works across — FMCG, fashion, beauty, F&B, tech, automotive, travel, health and home & lifestyle." />

    <section className="svc-hero">
      <div className="shell">
        <div className="crumb">
          <a href="/">Home</a><span className="sep">/</span> Sectors
        </div>
        <span className="eyebrow">Sectors we serve</span>
        <h1>Nine sectors. A distinct playbook for each.</h1>
        <p className="lede">
          We do not pretend that a beauty launch and a SaaS go-to-market should run on the same playbook. The sectors below
          each have their own channel mix, regulatory stack and creative bar — and we operate against them accordingly.
        </p>
      </div>
    </section>

    <section className="band">
      <div className="shell">
        <Atlas />
      </div>
    </section>

    <section className="band band--soft">
      <div className="shell">
        <div className="section-title section-title--left">
          <span className="eyebrow">In detail</span>
          <h2 style={{ maxWidth: 720 }}>How we approach each sector.</h2>
        </div>
        <div className="atlas">
          {detail.map((d, i) => (
            <div key={d.title} className="place">
              <span className="badge">SECTOR {String(i + 1).padStart(2, "0")}</span>
              <h4>{d.title}</h4>
              <p>{d.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <Invite
      eyebrow="Pick a sector"
      title="Send us your category. We will respond with a one-page Türkiye view."
      text="We will outline what makes this sector distinctive in Türkiye, where international brands typically underperform, and what a credible 12-24 month launch and scale plan looks like."
    />
  </Frame>
);

export default Markets;
